import { Link } from 'react-router-dom';

interface CategoryEntryProps {
  movieCount: number;
  tvCount: number;
}

const ENTRIES = [
  {
    type: 'movie',
    title: '电影',
    desc: '院线新片、经典佳作，一部部看个够',
    icon: 'ri-film-line',
  },
  {
    type: 'tv',
    title: '电视剧',
    desc: '热播剧集、口碑长剧，追更不掉队',
    icon: 'ri-live-line',
  },
] as const;

export default function CategoryEntry({ movieCount, tvCount }: CategoryEntryProps) {
  const counts: Record<string, number> = { movie: movieCount, tv: tvCount };

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
      {ENTRIES.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50 md:p-6"
        >
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-16 md:w-16">
            <i className={`${entry.icon} text-2xl md:text-3xl`} />
          </span>
          <span className="flex min-w-0 flex-1 flex-col">
            <span className="flex items-baseline gap-2">
              <span className="text-lg font-bold text-foreground-950 md:text-xl">{entry.title}</span>
              <span className="text-xs text-foreground-500">{counts[entry.type]} 部</span>
            </span>
            <span className="mt-1 truncate text-sm text-foreground-600">{entry.desc}</span>
          </span>
          <i className="ri-arrow-right-line shrink-0 text-xl text-foreground-400 transition-colors group-hover:text-primary-600" />
        </Link>
      ))}
    </div>
  );
}